import { Link } from 'theSource/components';
import { Contact, Contacts } from 'theSource/features/Contacts/types';

export interface ContactField {
  label: string;
  value: string | JSX.Element;
  required?: boolean;
}

export const getSelectedContact = (
  contacts: Contacts,
  contactId: string | undefined
): Contact | undefined => {
  const contact = [...contacts.employerContacts, ...contacts.userContacts].find(
    (contact) => contact.id.toString() === contactId
  );

  return contact;
};

export const getContactFields = (contact?: Contact): ContactField[] => {
  if (!contact) {
    return [];
  }

  const fields = [
    {
      label: 'Title',
      value: contact.title,
    },
    {
      label: 'Email Address',
      value: contact.email ? (
        <Link variant="body1" type="email" value={contact.email} />
      ) : (
        ''
      ),
    },
    {
      label: 'Cell Phone',
      value: contact.cellPhone ? (
        <Link variant="body1" type="tel" value={contact.cellPhone} />
      ) : (
        ''
      ),
    },
    {
      label: 'Home Phone',
      value: contact.homePhone ? (
        <Link variant="body1" type="tel" value={contact.homePhone} />
      ) : (
        ''
      ),
    },
    {
      label: 'Work Phone',
      value: contact.workPhone ? (
        <Link variant="body1" type="tel" value={contact.workPhone} />
      ) : (
        ''
      ),
    },
    {
      label: 'Address',
      value: contact.address,
    },
    {
      label: 'Notes',
      value: contact.notes,
    },
    {
      label: 'Website',
      value: contact.url ? (
        <Link variant="body1" type="url" value={contact.url} />
      ) : (
        ''
      ),
    },
    {
      label: 'Groups',
      value: contact.groups.join('\r\n'),
    },
  ];

  return fields.filter((field) => field.value);
};
